import { render, staticRenderFns } from "./LoanPageEditableBox.vue?vue&type=template&id=dc37e2aa"
import script from "./LoanPageEditableBox.vue?vue&type=script&lang=js"
export * from "./LoanPageEditableBox.vue?vue&type=script&lang=js"
import style0 from "./LoanPageEditableBox.vue?vue&type=style&index=0&id=dc37e2aa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports